import React from 'react';

import {Label, Select, Textarea} from 'Components/Form';

/*
Example...
<Dietaries
    value={form.dietaries}
    error={getFieldError('dietaries')}
    onChange={(v) => handleInput('dietaries', v)}
/>
*/

export default class Dietaries extends React.Component {
    /**
     * @var options
     * @type {array}
     */
    options = [
        {
            label: 'None',
            value: 'None'
        },
        {
            label: 'Gluten free',
            value: 'Gluten free'
        },
        {
            label: 'Coeliac',
            value: 'Coeliac'
        },
        {
            label: 'Dairy and Lactose free',
            value: 'Dairy and Lactose free'
        },
        {
            label: 'Vegetarian',
            value: 'Vegetarian'
        },
        {
            label: 'Vegan',
            value: 'Vegan'
        },
        {
            label: 'Other',
            value: 'Other'
        }
    ];

    /**
     * @method handleChange
     * @param {string} key
     * @param {string} v
     */
    handleChange = (key, v) =>  {
        const {value, onChange} = this.props;

        onChange({
            ...value,
            [key]: v
        });
    }

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {
            value,
            error,
            me
        } = this.props;

        return (
            <div className='flex flex-col gap-4'>
                <p className="font-bold">
                    Dietary Requirements
                </p>

                {error &&
                    <Label 
                        label="" 
                        error={error}
                    />
                }

                <Select
                    label={me ?
                        "Do you have any dietary requirements?" :
                        "Does the individual have any dietary requirements?"
                    }
                    value={value?.dietaries}
                    onChange={(v) => this.handleChange('dietaries', v)}
                    options={this.options}
                />

                {value?.dietaries === 'Other' &&
                    <Textarea
                        label="Please provide details of the dietary requirements..."
                        value={value?.other}
                        onChange={(v) => this.handleChange('other', v)}
                    />
                }
            </div>
        );
    }
}